import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

export const LegalLayout = () => {
    return (
        <div className="min-h-screen bg-surface-app flex flex-col">
            <header className="p-6 border-b border-border flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2 text-content hover:text-cyan-400 transition-colors">
                    <ShieldCheck size={24} />
                    <span className="font-bold tracking-tight">L'IAmani</span>
                </Link>
            </header>
            <main className="flex-1 p-6 md:p-12 max-w-4xl mx-auto w-full text-content-muted">
                <Outlet />
            </main>
            <footer className="p-6 border-t border-border text-center text-xs text-content-muted">
                &copy; {new Date().getFullYear()} L'IAmani. Tous droits réservés.
            </footer>
        </div>
    );
};
